<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr">
        <span>Contract Period</span>
        <span v-copy="getAllOptionName24('period', quoteForm.contr_prd)">{{ getAllOptionName24('period', quoteForm.contr_prd) }}</span>
      </div>
      <div class="tr">
        <span>Building Age</span>
        <span v-copy="getAllOptionName24('bldg_ages', quoteForm.bldg_age)">{{ getAllOptionName24('bldg_ages', quoteForm.bldg_age) }}</span>
      </div>
      <div class="tr">
        <span>Total Contract Sum</span>
        <span v-copy="quoteForm.tol_contr_sum">{{ quoteForm.tol_contr_sum }}</span>
      </div>
      <div class="tr">
        <span>Material Damage Coverage</span>
        <span v-copy="getOptionName('yesNoOptions', quoteForm.mat_dam_cvr_ind)">{{ getOptionName('yesNoOptions', quoteForm.mat_dam_cvr_ind) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Liability Coverage </span>
        <span v-copy="getOptionName('yesNoOptions', quoteForm.tp_lia_cvr_ind)">{{ getOptionName('yesNoOptions', quoteForm.tp_lia_cvr_ind) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Liability Limit</span>
        <span v-copy="getAllOptionName24('limit_of_liability', quoteForm.tppd_limit_amt)">{{ getAllOptionName24('limit_of_liability', quoteForm.tppd_limit_amt) }}</span>
      </div>
      <div class="tr">
        <span>Outdoor Work  or Scaffolding Work</span>
        <span v-copy="getOptionName('yesNoOptions', quoteForm.outdoor_wk_ind)">{{ getOptionName('yesNoOptions', quoteForm.outdoor_wk_ind) }}</span>
      </div>
      <div
        v-if="quoteForm.outdoor_wk_ind == 1"
        class="tr">
        <span>Total Contract Value of Outdoor Work and/or Scaffolding Work</span>
        <span v-copy="getAllOptionName24('scaffolding_wk', quoteForm.scaffolding_wk)">{{ getAllOptionName24('scaffolding_wk', quoteForm.scaffolding_wk) }}</span>
      </div>
      <div class="tr">
        <span>Employee Compensation</span>
        <span v-copy="getOptionName('yesNoOptions', quoteForm.employee_ind)">{{ getOptionName('yesNoOptions', quoteForm.employee_ind) }}</span>
      </div>
      <div class="tr">
        <span>
          <!--          <p-->
          <!--            v-for="(item,index) in underwriting"-->
          <!--            :key="index">-->
          <!--            {{item.name}}-->
          <!--          </p>-->
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'DecorationQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName24('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
